export default {
  init() {
    // JavaScript to be fired on the home page
    $('.header-wrapper').removeClass('white-bg');
  },
  finalize() {
    $(window).scroll(function() {
        var scroll = $(window).scrollTop();
        if (scroll >= 400) {
            $('.header-wrapper').addClass('white-bg');
        } else {
            $('.header-wrapper').removeClass('white-bg');
        }
    });
    jQuery('.modal').modal();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js